<div class="message-count" [@updatedTrigger]="updated">
    {{ currentMessage }} of {{ totalMessages }}
</div>
